import { z } from 'zod';

export const exploreConfigurationSchema = z.object({
  isGlobal: z.boolean().default(false),
  isRandomized: z.boolean().default(false),
  subtitle: z.string(),
  tags: z.array(z.string()),
  title: z.string(),
});

export type ExploreConfiguration = z.infer<typeof exploreConfigurationSchema>;
